import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./dashboard.css";

const BASE_URL = "https://sutmmg.codydeasoftech.in/api";

const Dashboard = () => {
  const navigate = useNavigate();
  const user_type_id = localStorage.getItem("userTypeId");
  const token = localStorage.getItem("token");

  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  // 🔹 FETCH DASHBOARD COUNTS
  useEffect(() => {
    fetchDashboardCounts();
  }, []);

  const fetchDashboardCounts = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/dashboard`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCounts(res.data.data || {});
    } catch (err) {
      if (err.response && err.response.status === 401) {
        console.warn("Session expired / Unauthorized");

        localStorage.removeItem("token");
        localStorage.removeItem("userTypeId");

        if (user_type_id === "1") {
          navigate("/suda/login");
        } else if (user_type_id === "2") {
          navigate("/ulb/login");
        } else {
          navigate("/landing");
        }
      } else {
        console.error("Dashboard count fetch failed", err);
      }
    } finally {
      setLoading(false);
    }
  };

  const role1Categories = [
    { name: "Zones", count: counts.zones || 0, slug: "zone", color: "#2563EB", icon: "fa-layer-group" },
    { name: "Districts", count: counts.districts || 0, slug: "district", color: "#F59E0B", icon: "fa-map-location" },
    { name: "Municipalities", count: counts.municipalities || 0, slug: "municipality", color: "#4F46E5", icon: "fa-city" },
    { name: "Items", count: counts.items || 0, slug: "item", color: "#f08b6d", icon: "fa-box" },
    { name: "Sizes", count: counts.sizes || 0, slug: "size-list", color: "#e63933", icon: "fa-ruler" },
    { name: "Fabric Consumptions", count: counts.fabric_consumptions || 0, slug: "fabric-consumptions", color: "#a9c6fe", icon: "fa-chart-pie" },
    { name: "School Categories", count: counts.school_categories || 0, slug: "category-list", color: "#ffb8cc", icon: "fa-layer-group" },
    { name: "School Types", count: counts.school_types || 0, slug: "school-types", color: "#4165e0", icon: "fa-list" },
    { name: "School Managements", count: counts.school_managements || 0, slug: "school-management-types", color: "#135db8", icon: "fa-school" },
    { name: "CLFS", count: counts.clfs || 0, slug: "", color: "#344b5d", icon: "fa-layer-group" },
    { name: "ALFS", count: counts.alfs || 0, slug: "", color: "#c96235", icon: "fa-diagram-project" },
    { name: "SHGS", count: counts.shgs || 0, slug: "", color: "#f4b453", icon: "fa-users" },
    { name: "SHG Members", count: counts.members || 0, slug: "", color: "#0D5EA6", icon: "fa-user-group" },
    { name: "Schools", count: counts.schools || 0, slug: "", color: "#c4a883", icon: "fa-school" },
    { name: "Total Students ", count: counts.students_count || 0, slug: "", color: "#16A34A", icon: "fa-users" },
    { name: "Measurements Taken Students", count: counts.measurements_taken_count || 0, slug: "", color: "#7C3AED", icon: "fa-file-invoice" },
  ];

  const role2Categories = [
    { name: "Items", count: counts.items || 0, slug: "item", color: "#f08b6d", icon: "fa-box" },
    { name: "Sizes", count: counts.sizes || 0, slug: "size-list", color: "#e63933", icon: "fa-ruler" },
    { name: "Fabric Consumptions", count: counts.fabric_consumptions || 0, slug: "fabric-consumptions", color: "#a9c6fe", icon: "fa-chart-pie" },
    { name: "School Categories", count: counts.school_categories || 0, slug: "category-list", color: "#ffb8cc", icon: "fa-layer-group" },
    { name: "School Types", count: counts.school_types || 0, slug: "school-types", color: "#4165e0", icon: "fa-list" },
    { name: "School Managements", count: counts.school_managements || 0, slug: "school-management-types", color: "#135db8", icon: "fa-school" },
    { name: "Schools", count: counts.schools || 0, slug: "school", color: "#c4a883", icon: "fa-users" },
    { name: "CLFS", count: counts.clfs || 0, slug: "cluster-level-federation", color: "#344b5d", icon: "fa-layer-group" },
    { name: "ALFS", count: counts.alfs || 0, slug: "area-level-federation", color: "#c96235", icon: "fa-diagram-project" },
    { name: "SHGS", count: counts.shgs || 0, slug: "self-help-group", color: "#f4b453", icon: "fa-users" },
    { name: "SHG Members", count: counts.members || 0, slug: "member", color: "#0D5EA6", icon: "fa-user-group" },
    { name: "Total Students ", count: counts.students_count || 0, slug: "", color: "#16A34A", icon: "fa-users" },
    { name: "Measurements Taken Students", count: counts.measurements_taken_count || 0, slug: "measurement-list", color: "#0D5EA6", icon: "fa-school" },
  ];

  const role3Categories = [
    { name: "Fabric Cutting", slug: "dummy-1", color: "#ff6b6b", icon: "fa-box" },
    { name: "Stiching", slug: "dummy-2", color: "#6bafff", icon: "fa-cube" },
  ];

  let categories = [];
  if (user_type_id === "1") categories = role1Categories;
  else if (user_type_id === "2") categories = role2Categories;
  else if (user_type_id === "3") categories = role3Categories;

  return (
    <div className="container py-4">
      <h2 className="dash-title mb-4">
        {user_type_id === "1" && "Super Admin Panel"}
        {user_type_id === "2" && "Municipality Panel"}
        {user_type_id === "3" && "Vendor Panel"}
      </h2>

      <div className="row">
        {categories.map((item, index) => (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={index}>
            <div
              className="dash-card"
              style={{
                background: item.color,
                borderRadius: "18px",
                padding: "20px",
                minHeight: "150px",
                boxShadow: `0 10px 25px ${item.color}55`,
                position: "relative",
                cursor: "pointer",
              }}
              onClick={() => !loading && navigate(`/app/${item.slug}`)}
            >
              {/* Show loader or count - SMALLER VERSION */}
              {loading ? (
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                    style={{ color: "#fff", width: "20px", height: "20px", fontSize: "12px" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span style={{ fontWeight: "600", color: "#fff", opacity: 0.8, fontSize: "14px" }}>
                    Loading...
                  </span>
                </div>
              ) : (
                <h2 style={{ fontWeight: "800", color: "#fff" }}>{item.count}</h2>
              )}

              <p style={{ color: "#fff", fontWeight: "bold", fontSize: "18px" }}>{item.name}</p>

              <i
                className={`fa-solid ${item.icon}`}
                style={{
                  position: "absolute",
                  right: "18px",
                  top: "20px",
                  fontSize: "50px",
                  opacity: 0.25,
                  color: "#fff",
                }}
              />

              <div
                style={{
                  marginTop: "15px",
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                More info <i className="fa-solid fa-arrow-right"></i>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
